import React from 'react';
import { Loader2 } from 'lucide-react';

const LoadingBrands = () => (
  <div className="bg-white dark:bg-slate-900 rounded-xl border border-gray-200 dark:border-slate-700 p-8 transition-colors duration-300">
    <div className="text-center">
      <div className="space-y-4">
        {[1, 2, 3].map((i) => (
          <div key={i} className="bg-gray-50 dark:bg-slate-800 rounded-lg p-4 animate-pulse">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-8 h-8 bg-gray-300 dark:bg-slate-600 rounded-md"></div>
              <div className="flex-1">
                <div className="h-4 bg-gray-300 dark:bg-slate-600 rounded w-32 mb-1"></div>
                <div className="h-3 bg-gray-300 dark:bg-slate-600 rounded w-48"></div>
              </div>
              <div className="flex gap-2">
                <div className="h-6 bg-gray-300 dark:bg-slate-600 rounded w-12"></div>
                <div className="h-6 bg-gray-300 dark:bg-slate-600 rounded w-16"></div>
              </div>
            </div>
            <div className="h-px bg-gray-300 dark:bg-slate-600 mb-3"></div>
            <div className="grid grid-cols-4 gap-3">
              {[1, 2, 3, 4].map((j) => (
                <div key={j} className="bg-gray-200 dark:bg-slate-700 rounded-lg p-3">
                  <div className="h-4 bg-gray-300 dark:bg-slate-600 rounded w-8 mb-2"></div>
                  <div className="h-3 bg-gray-300 dark:bg-slate-600 rounded w-full"></div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default LoadingBrands;